import { EditorialCard } from '../editorial-card/editorial-card';
import { NewAtosLogoRelative } from '../icons-library/new-atos-logo-relative';
import { mapPageToListCardData, PageListCardSource } from './map-page-to-list-card-data';

const LogoFallback = () => (
    <div class="absolute inset-0 flex items-center justify-center">
        <NewAtosLogoRelative />
    </div>
);

export const PagePostCard = (props: { data: PageListCardSource }) => {
    return (
        <EditorialCard
            data={mapPageToListCardData(props.data)}
            myContentType="page"
            mediaFallback={<LogoFallback />}
        />
    );
};
